import { render, staticRenderFns } from "./SimulationDetailsComponent.vue?vue&type=template&id=c28bc72a&"
import script from "./SimulationDetailsComponent.vue?vue&type=script&lang=js&"
export * from "./SimulationDetailsComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports